
<template>
    <div>
        <mars-view class="container" @click.native="clickAll"><mars-view id="top-bar-box"><top-bar :title="topBar.title" text-color="#242A33"></top-bar></mars-view><mars-view v-show="!topLoading && filters && filters.length" class="search-container"><mars-view class="search-bar-wrapper" :style="{'top': entireHeight + 'px'}"><mars-view class="search-bar l-span c-font-normal" @click.native="searchInput"><mars-view class="search-bar-icon"></mars-view><mars-view class="search-bar-placeholder">
                    请输入律师姓名
                </mars-view></mars-view><my-filter v-if="filters && filters.length" class="expert-filters" :selections="filters" :primary-color="themeColor" mask-color="rgba(0, 0, 0, .4)" item-select-strategy="strict" type="list" @change="filterChangeFn" @taglayouttap="filterClickFn"></my-filter></mars-view><mars-view v-if="topLoading"><c-loading class="loading"></c-loading></mars-view><mars-view v-else><mars-view v-if="(searchResult && searchResult.length !== 0) || (recommendedLawyerList && recommendedLawyerList.length !== 0)" class="search-result-wrapper"><mars-view v-if="searchResult && searchResult.length" class="search-result-experts top-padding-9"><mars-view v-for="(expert, index) in searchResult" :key="index" :data-key="'expertlist_' + expert.qc_core_no" :data-index="index" :data-id="expert.qc_core_no" class="search-result-expert"><new-lawyer v-if="expert.type === 'lawyer'" :class="'expertlist-law-show-' + expert.pageNum" :log="getLog(expert.data, index)" :lawyer-info="expert.data" :idx="index + 1" data-serverid="16199" :page-from="'expertlist'" :data-key="'expertlist_' + expert.data.qc_core_no" data-page="expertlist" data-area="list-page-lawyer-show" :data-exts="JSON.stringify({
                                consult_type: filterParams.expertiseArea || '',
                                qcNo: expert.data.qc_core_no,
                                rsId: expert.data.rs_id,
                                name: expert.data.lawyer_name,
                                index: index + 1,
                                members: expert.data.members_icon || '',
                                ident: expert.data.expert_ident || '',
                                lawyer_type: expert.data.lawyer_type || '',
                                fr: 'list',
                                uk: expert.data.uk,
                            })" :data-extswan="{
                                consult_type: filterParams.expertiseArea || '',
                                qcNo: expert.data.qc_core_no,
                                rsId: expert.data.rs_id,
                                name: expert.data.lawyer_name,
                                index: index + 1,
                                vipType: expert.data.vip_type,
                                members: expert.data.members_icon || '',
                                ident: expert.data.expert_ident || '',
                                lawyer_type: expert.data.lawyer_type || '',
                                fr: 'list',
                                uk: expert.data.uk,
                            }"></new-lawyer><mars-view v-else class="expertlist-online-consult-card" :log="getLog(expert, index)" :data-key="'expertlist_' + expert.qc_core_no" data-value="attorney-area-show" :data-ext="JSON.stringify(getExt(expert, index))" :data-extswan="getExt(expert, index)"><online-consult-card :ad-type="expert.type" :ad-url="expert.url" page-form="expertList"></online-consult-card></mars-view></mars-view></mars-view><mars-view v-if="noMoreResult" class="l-text-center c-font-normal c-color-gray c-gap-inner-bottom-large  c-gap-inner-top-large no-more-result">
                    找不到更多符合查询条件的律师，为您推荐其他律师
                </mars-view><mars-view v-if="recommendedLawyerList && recommendedLawyerList.length" class="search-result-experts top-padding-9"><mars-view v-for="(expert, index) in recommendedLawyerList" :key="index" :data-key="'expertlist_' + expert.qc_core_no" :data-index="index" :data-id="expert.qc_core_no" class="search-result-expert"><new-lawyer :class="'expertlist-recommend-law-show-' + expert.pageNum" :log="getLog(expert.data, index)" :lawyer-info="expert.data" :idx="index" data-serverid="16199" :page-from="'expertlist'" :data-key="'expertlist_' + expert.data.qc_core_no" data-page="expertlist" data-area="list-page-lawyer-show" :data-exts="JSON.stringify({
                                consult_type: filterParams.expertiseArea || '',
                                qcNo: expert.data.qc_core_no,
                                rsId: expert.data.rs_id,
                                name: expert.data.lawyer_name,
                                index: index + 1,
                                members: expert.data.members_icon || '',
                                ident: expert.data.expert_ident || '',
                                lawyer_type: expert.data.lawyer_type || '',
                                fr: 'list',
                                uk: expert.data.uk,
                                isRecommend: 1,
                            })" :data-extswan="{
                                consult_type: filterParams.expertiseArea || '',
                                qcNo: expert.data.qc_core_no,
                                rsId: expert.data.rs_id,
                                name: expert.data.lawyer_name,
                                index: index + 1,
                                vipType: expert.data.vip_type,
                                members: expert.data.members_icon || '',
                                ident: expert.data.expert_ident || '',
                                lawyer_type: expert.data.lawyer_type || '',
                                fr: 'list',
                                uk: expert.data.uk,
                                isRecommend: 1,
                            }"></new-lawyer></mars-view></mars-view><mars-view v-if="bottomLoading" class="l-span-center"><mars-image class="bottom-loading-icon" :lazy-load="true" src="https://lvlin-base.cdn.bcebos.com/law/pages/new-home/Vector.png"></mars-image></mars-view></mars-view></mars-view></mars-view></mars-view>
    </div>
</template>

<script>
/* globals getCurrentPages, swan */
import Topbar from "../../components/common/topbar.vue";
import Loading from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Loading/Loading.vue";
import { getData } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import NewLawyer from "../../components/home/new-lawyer.vue";
import MyFilter from "../../components/common/filter.vue";
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import onlineConsultCard from "../../components/common/onlineConsultCard.vue";
import { handleSearch } from '../../static/utils/search';
import { inSightObserverDisconnects, inSightObservers } from '../../common/js/repeatExposureLog.js';
import log from '../../static/utils/ubcLog';
import { act } from '../../static/utils/navigate.js';
import * as location from '../../static/utils/location';
import { getStorage } from '../../static/utils/core';
export default {
  components: {
    'top-bar': Topbar,
    'new-lawyer': NewLawyer,
    'c-loading': Loading,
    'online-consult-card': onlineConsultCard,
    'my-filter': MyFilter
  },
  data() {
    return {
      topLoading: true,
      bottomLoading: false,
      noMoreResult: false,
      isReccommendLawyerhasMore: false,
      isLawyerhasMore: false,
      entireHeight: 64,
      page_num: 1,
      // 当前页数
      page_size: 10,
      // 每页数量
      filterParams: {},
      // 当前筛选参数
      filterTop: 0,
      asyncExpertUrl: '',
      themeColor: '#0055FF',
      topBar: {
        title: '律师列表',
        color: '#000',
        bgColor: '#fff'
      },
      postUrl: '',
      searchResult: [],
      recommendedLawyerList: [],
      searchBar: {},
      filters: [],
      menu: [],
      defaultProvince: '',
      currentCity: '',
      countyCode: '',
      // query参数携带的county_code
      // 推荐几位优选律师
      randomNum: 5,
      ts: '',
      isUpdateLawyer: true,
      expertAreaDefaultValue: '',
      // 二级领域默认值
      ctx: {},
      qcCoreNoInfo: {},
      tabName: '' // 最新一次点击时的tab类型,
    };
  },

  mounted() {
    this.entireHeight = 44;
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  methods: {
    searchInput() {
      log.send({
        // 旧打点，先做保留
        area: 'search_click',
        action: 'click'
      });
      act({
        target: '/pages/search/index',
        type: 'url'
      });
    },
    /**
    * setFilterParams
    * 设置 页面 统一请求参数FilterParams
    *
    * @param {string} key FilterParams key: 1、city：地址 2、expertiseArea：咨询类型
    * @param {Object} value FilterParams value
    */
    setFilterParams(key, value) {
      this.filterParams[key] = value;
    },
    init(options = {}, reqData) {
      this.setRequestLock(true);
      const P1 = getData({
        url: this.getFristDataUrl,
        loginNeeded: false,
        data: {
          page_num: this.page_num,
          page_size: this.page_size,
          random_num: this.randomNum,
          ts: this.ts || options.ts || '',
          list_type: 1,
          ...reqData
        }
      });
      const {
        name = '',
        city = ''
      } = options;
      const cityUrl = reqPathTo('getallcity', options, '', 'falv/city');
      const P2 = getData({
        url: cityUrl
      });
      Promise.all([P1, P2]).then(([res1, res2]) => {
        let cityFilter = {};
        const reqCity = res1 && res1.req_city_name || '';
        this.currentCity = reqCity;
        log.addKey({
          cityName: this.currentCity && this.currentCity.replace('市', '')
        });
        getApp().globalData.location.cityName = reqCity.replace('市', ''); // eslint-disable-line
        cityFilter = this.formatCityData(res2, res1);
        res1 && this.formatListData(res1, cityFilter);
        // 推流链接携带query参数跳转过来后，律师列表数据过少的页面兜底数据展示
        if (this.ctx.name && res1.lawyer_list.length < 10) {
          this.page_num = 1;
          this.noMoreResult = true;
          this.bottomLoading = false;
          this.setRequestLock(false);
          this.getReccommendLawyerList();
        }
        // 律师列表页精确到链接 query 参数 name 维度的 TDK 参数信息
        if (name !== '') {
          const {
            primary_type = [],
            personal_intro = ''
          } = res1.lawyer_list && res1.lawyer_list[0] && res1.lawyer_list[0].data || {};
          const areaStr = primary_type.map(item => {
            return item + '律师';
          });
          const title = `${name}律师${areaStr[0] ? ` - ${city}` + areaStr[0] : ''}${areaStr[1] ? ' - ' + areaStr[1] : ''} - 百度律临`;
          const keywords = `${name}律师、${city && city + '律师、'}${areaStr[0] ? areaStr[0] + '、' : ''}${areaStr[1] ? areaStr[1] + '、' : ''}` + '律临、法律服务、专业法律服务、法律服务平台、律师咨询、法律咨询、24小时热线、免费咨询、律师咨询免费、律师在线咨询、律所';
          // 若搜索结果仅有一个律师，则直接返回该律师的介绍，否则返回一个默认的介绍
          const description = res1.lawyer_list.length === 1 ? personal_intro : `百度律临法律服务平台，为您提供${name}律师的法律咨询服务，您可以在这里快速咨询${name}律师，同时了解更多关于${name}律师的法律案例、文章等信息，为您及时解决法律难题！`;
          setPageInfoMenu({
            title,
            keywords,
            description
          });
        }
        const isGetLocation = getStorage('location');
        if (!isGetLocation) {
          this.handlePosition(reqCity);
        }
      });
    },
    handlePosition() {
      location.get().then(res => {
        if (res.cityName && this.currentCity && res.cityName.indexOf(this.currentCity) === -1) {
          this.noMoreResult = false;
          this.isReccommendLawyerhasMore = false;
          this.recommendedLawyerList = [];
          this.searchResult.length = 0;
          this.page_num = 1;
          this.ts = '';
          this.setRequestLock(false);
          getApp().globalData.location.cityName = res.cityName.replace('市', ''); // eslint-disable-line
          this.currentCity = res.cityName;
          this.setFilterParams('city_name', res.cityName);
          this.init(this.ctx, this.filterParams, true);
        }
      });
    },
    initPageData() {
      this.noMoreResult = false;
      this.isReccommendLawyerhasMore = false;
      this.searchResult = [];
      this.recommendedLawyerList = [];
      this.searchResult.length = 0;
      this.page_num = 1;
      this.ts = '';
      this.setRequestLock(false);
    },
    // 点击tab时，更新tabLogArea
    filterClickFn(e) {
      let {
        option = {}
      } = e || {};
      let {
        originText
      } = option || {};
      this.tabName = originText || '';
    },
    // 筛选器用 页面更新方法
    filterChangeFn(options) {
      if (this.requestLock) {
        return;
      }
      this.initPageData();

      // 获取参数
      let res = options.allResults;
      const cityInfo = res.city_name && res.city_name.options && res.city_name.options[0] || {};
      res.city_code = {
        value: cityInfo.parentCode || ''
      };
      res.county_code = {
        value: cityInfo.code || ''
      };
      // 解析原始对象
      Object.keys(res).map(v => {
        if (v !== 'type') {
          this.filterParams[v] = res[v].value;
        }
      });
      getApp().globalData.location.cityName = cityInfo && cityInfo.parentValue && cityInfo.parentValue.replace('市', ''); // eslint-disable-line
      let ext = {};
      let logArea = '';
      this.currentCity = cityInfo && cityInfo.parentValue && cityInfo.parentValue.replace('市', '');
      switch (this.tabName) {
        case '所在地区':
          logArea = 'lawyer-diyu';
          ext.cityName = this.filterParams.city_name || '';
          break;
        case '专长领域':
          logArea = 'lawyer-lingyu';
          ext.expertiseArea = this.filterParams.expertiseArea || '';
          break;
        case '从业年限':
          logArea = 'lawyer-nianxian';
          ext.year = this.filterParams.year || '';
          break;
      }

      // 单纯的tab点击行为不会触发打点、只会对引起页面更新的tab点击行为进行打点
      log.send({
        area: logArea,
        action: 'click',
        ext: JSON.stringify(ext)
      });
      // 筛选器选择地址 同步到 gloabl
      getApp(); // eslint-disable-line
      // filter筛选
      this.topLoading = true;
      this.updateExpertList().then(() => {
        this.topLoading = false;
      });
    },
    updateExpertList() {
      this.setRequestLock(true);
      // 异步请求律师
      const {
        expertiseArea = '',
        year = '',
        county_code = '',
        city_code = ''
      } = this.filterParams || {}; // eslint-disable-line
      log.addKey({
        cityName: this.currentCity && this.currentCity.replace('市', ''),
        lawyerField: expertiseArea
      });
      return this.$api.request({
        url: reqPathTo('lawyerlist', {}, '', 'falv/lawyer'),
        data: {
          ts: this.ts,
          credentials: true,
          page_num: this.page_num,
          page_size: this.page_size,
          random_num: this.page_num === 1 ? this.randomNum : '',
          expertiseArea,
          year,
          city_name: this.currentCity || '',
          county_code,
          city_code,
          list_type: 1
        }
      }).then(res => {
        try {
          let {
            lawyer_list = [],
            filters,
            ts,
            is_backup
          } = res.data.data;
          if (!lawyer_list.length || is_backup === '1') {
            this.page_num = 1;
            this.noMoreResult = true;
            this.bottomLoading = false;
            this.setRequestLock(false);
            this.getReccommendLawyerList();
            return;
          }
          lawyer_list = lawyer_list.map(item => {
            item.lawyer_service = [item.lawyer_service] || '';
            const value = {
              qc_core_no: item.qc_core_no,
              type: 'lawyer',
              data: item
            };
            return value;
          });
          this.searchResult = [...this.searchResult, ...this.searchResultFilter(lawyer_list)];
          if (!this.filters) {
            this.filters = filters;
          }
          if (ts) {
            this.ts = ts;
          }
          if (lawyer_list.length === 0) {
            this.noMoreResult = true;
            this.bottomLoading = false;
          } else {
            this.page_num += 1;
          }
          this.$mpUpdated(() => {
            let observerTimeout = setTimeout(() => {
              inSightObservers('.expertlist-law-show-' + (this.page_num - 1 || 1), '', {}, [], true, true);
              clearTimeout(observerTimeout);
              observerTimeout = null;
            }, 0);
          });
          if (lawyer_list.length && lawyer_list.length < 10) {
            this.updateExpertList();
          }
        } catch (e) {
          console.log(e); // eslint-disable-line
        }

        this.setRequestLock(false);
      }).catch(() => {
        this.setRequestLock(false);
      });
    },
    // 用于过滤后端返回的律师的信息
    searchResultFilter(list) {
      let resultList = [];
      if (this.searchResult.length > 0) {
        resultList = this.filterMembersIcon(this.searchResult, list);
      } else {
        resultList = this.filterFirstList(list);
      }
      resultList = resultList.map(ele => {
        if (ele.data) {
          ele.data.avg_score = ele.data.avg_score && Math.round(ele.data.avg_score);
        }
        ele.pageNum = this.page_num;
        return ele;
      });
      return resultList;
    },
    // 首次请求 过滤优选推荐的重复数据
    filterFirstList(list) {
      let arr = list.filter(i => i);
      let referenceArr = arr.splice(0, this.randomNum);
      let arrId = [];
      referenceArr.forEach(ele => {
        arrId.push(ele.qc_core_no);
      });
      return referenceArr.concat(arr.filter(ele => !arrId.includes(ele.qc_core_no)));
    },
    // 分页过滤优选推荐的前randomNum位律师
    filterMembersIcon(firstList, newList) {
      // 从firstList中去取前randomNum位id并且存储
      let arr = [];
      for (let i = 0; i < this.randomNum; i = i + 1) {
        firstList[i] && arr.push(firstList[i].qc_core_no);
      }
      return newList.filter(ele => !arr.includes(ele.qc_core_no));
    },
    // 无限下拉异步请求律师
    getAsyncExperts() {
      if (this.requestLock) {
        return;
      }
      if (this.noMoreResult) {
        this.getReccommendLawyerList();
        return;
      }
      this.setRequestLock(true);
      this.bottomLoading = true;
      this.updateExpertList().then(() => {
        this.bottomLoading = false;
      });
    },
    // @description 添加统一的请求锁
    // init                初始化
    // filterChangeFn      参数变化              topLoading 加载态
    // getUpdateExpertList 页面状态重置           topLoading 加载态
    // getAsyncExperts     无限下拉异步请求律师    bottomLoading 下面的加载
    setRequestLock(bool = false) {
      if (bool !== this.requestLock) {
        this.requestLock = bool;
      }
    },
    getExt(row, i) {
      return {
        consult_type: this.filterParams.expertiseArea || '',
        id: row.qc_core_no,
        rsId: row.rs_id,
        name: row.lawyer_name,
        index: i,
        vipType: row.vip_type,
        fr: 'list',
        recommend_location_index: i + 1
      };
    },
    getLog(row, i) {
      return {
        page: 'expertList',
        value: 'attorney-area-click',
        ext: this.getExt(row, i)
      };
    },
    /**
     * 城市数据格式处理
     */

    formatCityData(cityData = {}, lawyerListData = {}) {
      const city = this.handleCityItem(cityData.area_list, 1, ''); // 补全全部选项
      return {
        // 默认值
        defaultValue: this.defaultProvince && this.currentCity ? `${this.defaultProvince},${this.currentCity},${lawyerListData.req_city_info && lawyerListData.req_city_info.county ? lawyerListData.req_city_info.county : 'all'}` : '',
        key: 'type',
        column: 3,
        text: '所在地区',
        type: 'list',
        options: city,
        hideBtnLayout: true
      };
    },
    /**
     * 处理城市单位数据
     * @param {Object} item 城市数据
     */

    handleCityItem(city, current = 1, parentValue, code) {
      const citys = city.map(item => {
        if (current === 2 && item.value && item.value.indexOf(this.currentCity) === 0) {
          this.defaultProvince = parentValue;
          this.currentCity = item.value;
        }
        if (current === 3 && code) {
          item.parentCode = code;
          item.parentValue = parentValue;
        }
        return {
          key: 'city_name',
          text: item.label,
          value: item.value,
          options: item.children && this.handleCityItem(item.children, current + 1, item.value, item.code) || null,
          ...item
        };
      });
      // 补全全部选项
      if (current === 3) {
        citys.unshift({
          key: 'city_name',
          text: '全部',
          parentValue: parentValue,
          value: 'all',
          code: '',
          parentCode: code
        });
      }
      return citys;
    },
    /**
     * 处理律师列表数据
     * @param {Object} data 律师数据
     * @param {Object} cityFilter 城市数据
     */

    formatListData(data, cityFilter) {
      data.filters.unshift(cityFilter);
      // 专长领域
      data.filters[1].column = Number(data.filters[1].level_count);
      data.filters[1].text = '专长领域';
      // 从业年限
      data.filters[2].column = Number(data.filters[2].level_count);
      data.filters[2].text = '从业年限';
      data.filters[2].defaultValue = '';
      this.ts = data.ts || '';
      // 一级领域
      let firstExpertArea = this.findFirstExpertArea(data.filters[1], this.expertAreaDefaultValue);
      // 更改领域默认值
      if (this.expertAreaDefaultValue) {
        data.filters[1].defaultValue = `${firstExpertArea},${this.expertAreaDefaultValue}`;
      } else {
        data.filters[1].defaultValue = '不限,不限';
      }
      data.lawyer_list = data.lawyer_list.map(item => {
        item.lawyer_service = [item.lawyer_service] || '';
        const value = {
          qc_core_no: item.qc_core_no,
          type: 'lawyer',
          data: item
        };
        this.qcCoreNoInfo[item.qc_core_no] = item.qc_core_no;
        return value;
      });
      Object.assign(this, data);
      this._menu && (this.menu = this._menu);
      this.asyncExpertUrl = this.postUrl;
      this.searchResult = this.searchResultFilter(this.lawyer_list);
      this.topLoading = false;
      this.setRequestLock(false);
      this.page_num += 1;
      // 判断是否显示特定类型的案件律师
      this.$mpUpdated(() => {
        this.$mp && this.$mp.scope && this.$mp.scope.removeSkeleton && this.$mp.scope.removeSkeleton();
        inSightObservers('.expertlist-law-show-' + (this.page_num - 1), '', {}, [], true, true);
        this.isUpdateLawyer = true;
      });
      // 首页出广告返回数量为12。 experiment_group: 1 命中广告
      if (data.is_backup === '1' || !data.lawyer_list || !data.lawyer_list.length) {
        this.noMoreResult = true;
        this.getReccommendLawyerList();
      }
    },
    /**
     * 获取推荐律师列表
     * 严格意义上是获取兜底律师列表（后端查询逻辑）
     */

    getReccommendLawyerList() {
      if (this.requestLock) {
        return;
      }
      this.requestLock = true;
      const {
        expertiseArea = '',
        year = '',
        county_code = '',
        city_code = ''
      } = this.filterParams || {}; // eslint-disable-line
      this.$api.request({
        url: reqPathTo('lawyerlistrecommend', {}, '', 'falv/lawyer'),
        data: {
          credentials: true,
          page_num: this.page_num,
          page_size: this.page_size,
          expertiseArea,
          year,
          city_name: county_code ? '' : this.ctx.city || '',
          county_code,
          city_code
        }
      }).then(res => {
        this.requestLock = false;
        let {
          data
        } = res && res.data || {};
        if (!data) {
          return;
        }
        let {
          lawyer_list = []
        } = data;
        if (!lawyer_list.length) {
          this.isReccommendLawyerhasMore = true;
          return;
        }
        lawyer_list = lawyer_list.map(item => {
          item.lawyer_service = [item.lawyer_service] || '';
          const value = {
            qc_core_no: item.qc_core_no,
            type: 'lawyer',
            data: item,
            pageNum: this.page_num
          };
          return value;
        });
        this.page_num += 1;
        this.recommendedLawyerList = [...this.recommendedLawyerList, ...this.lawyerListFilter(lawyer_list)];
        this.$mpUpdated(() => {
          let observerTimeout = setTimeout(() => {
            inSightObservers('.expertlist-recommend-law-show-' + (this.page_num - 1 || 1), '', {}, [], true, true);
            clearTimeout(observerTimeout);
            observerTimeout = null;
          }, 0);
        });
      }).catch(() => {
        this.requestLock = false;
      });
    },
    /**
     * 律师列表去重
     * @param {Array} 列表
    */

    lawyerListFilter(list) {
      if (!list) {
        return [];
      }
      return list.filter(item => {
        return !this.qcCoreNoInfo[item.qc_core_no];
      });
    },
    /**
     * 通过二级领域查找对应的一级领域
     * @param {Array} expertAreas 领域信息
     * @param {String} secondArea 二级领域
     */

    findFirstExpertArea(expertAreas, secondArea) {
      if (!expertAreas.options || !expertAreas.options.length) {
        return;
      }
      let firstArea = '';
      for (let i = 0; i < expertAreas.options.length; i++) {
        let item = expertAreas.options[i];
        // eslint-disable-next-line no-loop-func
        item.options && item.options.some(childItem => {
          if (childItem.text === secondArea) {
            firstArea = item.text;
            return true;
          }
        });
        // 跳出for循环
        if (firstArea) {
          break;
        }
      }
      return firstArea || '';
    },
    clickAll() {
      log.send({
        area: 'all-click',
        action: 'click'
      });
    },
    onReachBottom() {
      if (this.noMoreResult && this.isReccommendLawyerhasMore) {
        return;
      }
      this.getAsyncExperts();
    },
    onTabItemTap(item) {
      {
        log.send({
          serverId: 16138,
          area: ['bottom_index_click', 'bottom_bdls_click', 'bottom_lawyer_click', 'bottom_my_click'][item.index],
          action: 'click'
        });
      }
    }
  },
  created() {
    (function (ctx) {
      const app = getApp(); // eslint-disable-line
      const city = ctx.city || '';
      const expertiseArea = ctx.expertiseArea || '';
      const location = getStorage('location') || {};
      this.ctx = ctx;
      this.getFristDataUrl = reqPathTo('lawyerlist', ctx, '', 'falv/lawyer');
      this.currentCity = city || app.globalData.location.cityName || location.cityName || '';
      this.expertAreaDefaultValue = expertiseArea;
      this.countyCode = ctx.county_code || '';
      this.setFilterParams('city_name', this.currentCity);
      this.setFilterParams('expertiseArea', this.expertAreaDefaultValue);
      this.setFilterParams('county_code', this.countyCode);
      setPageInfoMenu({
        title: city + expertiseArea + '律师 - ' + '法律问题咨询 - 百度律临',
        keywords: `${city && city + '律师、'}${expertiseArea && expertiseArea + '律师、'}${city}${expertiseArea}律师咨询、律临、法律服务、法律服务平台、律师咨询、法律咨询、24小时热线、免费咨询、律师咨询免费、律师在线咨询`,
        description: `百度律临法律服务平台，为您提供专业的${city + expertiseArea}律师免费法律咨询服务，您可以在这里了解更多关于${city + expertiseArea}律师的法律案例、文集等法律知识信息，在线咨询${city + expertiseArea}律师，为您解决法律难题！`
      });
      if (this.currentCity) {
        app.globalData.location = {
          cityName: this.currentCity
        };
      }
      this.init(this.ctx, this.filterParams);
      const fr = ctx.ref || ctx.fr || handleSearch();
      log.addKey({
        serverId: '16199',
        fr,
        page: 'expertlist',
        location: city,
        cityName: this.currentCity,
        lawyerField: expertiseArea || '不限',
        expertArea: expertiseArea || '不限'
      });
      log.send && log.send({
        // 为了统一搜索来源打点方式，新增一个all_show打点
        area: 'all_show',
        action: 'show'
      });
      log.send && log.send({
        // 旧打点，先做保留
        area: 'expertlist',
        action: 'show'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  destroyed() {
    (function () {
      inSightObserverDisconnects();
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.search-container {
  position: relative;
  background: #f5f6f9;
}
.search-container .search-bar-wrapper {
  position: fixed;
  z-index: 10;
  right: 0;
  left: 0;
  background: #fff;
  padding-top: 0.05rem;
}
.search-container .search-bar-wrapper .search-bar {
  margin: 0 0.13rem;
  height: 38px;
  border-radius: 19px;
  background: #f5f6f9;
  padding-left: 0.1rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.search-container .search-bar-wrapper .search-bar-icon {
  width: 16px;
  height: 16px;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/new-home/square/search-gray.png') no-repeat;
  background-size: 100% 100%;
  margin-right: 3px;
  vertical-align: text-top;
}
.search-container .search-bar-wrapper .search-bar-placeholder {
  color: #b7b9c1;
  font-size: 14px;
  line-height: 1;
}
.search-container .expert-filters {
  position: absolute;
  z-index: 10;
  top: 100%;
  right: 0;
  left: 0;
}
.search-container .expert-filters .border {
  border-bottom: none;
}
.search-container .expert-filters [class*='__border'] {
  border-bottom: none;
}
.search-container .expert-filters [class*='__triangle'] {
  width: 12px;
  height: 12px;
  border: none!important;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/firmlist/icon-arrow-down.png') no-repeat;
  background-size: 12px;
  background-position: center right;
  top: 6px!important;
}
.search-container .expert-filters [class*='__column'] [class*='__option'] {
  text-align: center;
}
.search-container .expert-filters [class*='__column'] [class*='__option-selected'] {
  background-color: #f5f5f5;
}
.search-container .expert-filters [class*='__column1'] {
  background-color: #f5f5f5;
}
.search-container .expert-filters [class*='__column1'] [class*='__option'] {
  background-color: #f5f5f5;
  text-align: left;
}
.search-container .expert-filters [class*='__column0'] {
  background-color: #f5f5f5;
}
.search-container .expert-filters [class*='__column0'] [class*='__option'] {
  background-color: #fff;
  text-align: left;
}
.search-container .expert-filters [class*='__column0'] [class*='__option-selected'] {
  background-color: #f5f5f5;
}
.search-container .expert-filters /deep/ .column .c-line-clamp1.c-font-normal {
  text-align: center;
}
.search-container .expert-filters /deep/ .column1 .c-line-clamp1.c-font-normal {
  text-align: left;
}
.search-container .expert-filters .c-line-clamp1,
.search-container .expert-filters [class*=_c-line-clamp1] {
  font-weight: 400 !important;
}
.search-container .no-result {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background: #f5f5f5;
}
.search-container .no-more-result {
  color: #848691;
  font-family: PingFang SC;
  font-size: 0.14rem;
  line-height: 1;
  padding: 0.21rem 0;
}
.search-container .search-result-wrapper {
  padding: 111px 10px 20px;
  min-height: calc(100vh - 142px);
}
.search-container .search-result-wrapper .search-result-experts {
  padding-top: 1px;
}
.search-container .search-result-wrapper .search-result-experts .search-result-expert {
  margin-top: -4px;
}
.search-container .search-result-wrapper .l-span-center {
  padding: 15px 0 0;
}
.search-container .search-result-wrapper .bottom-loading-icon {
  width: 20px;
  height: 20px;
  transform-origin: center center;
  animation: circles 1.5s linear infinite;
}
@keyframes circles {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.search-container .search-result-wrapper .top-padding-9 {
  background: #fff;
  border-radius: 0.12rem;
}
.search-container .join-card-box {
  padding-bottom: 0.05rem;
}
.search-container .loading {
  position: relative;
  top: 140px;
}
.search-container .expertlist-online-consult-card {
  margin-bottom: 10px;
}
.search-container .expertlist-online-consult-card /deep/ .banner-ad,
.search-container .expertlist-online-consult-card [class*='__banner-ad'] {
  padding-top: 0;
  padding-bottom: 0;
}

</style>
